// Return more data based on an error code so that we can be descriptive to the user
const imageUploadErrors = (code, type) => {
  const lotLabel = type.toLowerCase() === 'bin' ? 'item' : 'lot';

  switch (code) {
    case 'imageSeq':
      return {
        code: 'imageSeq',
        title: 'Invalid sequence number',
        description:
          'Your file sequence numbers must only contain numbers. Please rename and re-upload.',
        summary:
          'Your file(s) sequence numbers must only contain numbers.  Please rename and re-upload the following:'
      };
    case 'invalidImage':
      return {
        code: 'invalidImage',
        title: 'Image Processing Error',
        description:
          'There was an issue processing this image. Please try to re-upload.',
        summary:
          'There was an issue processing this image. Please re-upload the following:'
      };
    case 'invNum':
      return {
        code: 'invNum',
        title: 'Invalid inventory numbers',
        description:
          'Your file name doesn’t match an existing inventory number. Please rename and re-upload.',
        summary:
          'Your file name(s) doesn’t match an existing inventory number. Please rename and re-upload the following:'
      };
    case 'lotNum':
      return {
        code: 'lotNum',
        title: `Invalid ${lotLabel} numbers`,
        description: `Your file name doesn’t match an existing ${lotLabel} number. Please rename and re-upload.`,
        summary: `Your file name(s) doesn’t match any existing ${lotLabel} number. Please rename and re-upload the following:`
      };
    case 'pixel':
      return {
        code: 'pixel',
        title: 'Doesn’t meet minimum image size',
        description:
          'Your file doesn’t meet the minimum 1000px x 1000px size. Please resize and re-upload.',
        summary:
          'Your file(s) doesn’t meet the minimum 1000px x 1000px size. Please resize and re-upload the following:'
      };
    case 'safari':
      return {
        code: 'safari',
        title: 'Browser error',
        description:
          'Safari was unable to process this image. Please switch to Google Chrome or Firefox, then re-upload.',
        summary:
          'Safari was unable to process this image. Please switch to Google Chrome or Firefox, then re-upload the following:'
      };
    case 'size':
      return {
        code: 'size',
        title: 'Exceeds maximum file size',
        description: 'Your file exceeds the maximum size of 10 MB. Please resize and re-upload.',
        summary:
          'Your file(s) exceeds the maximum size of 10 MB. Please resize and re-upload the following:'
      };
    case 'timeout':
      return {
        code: 'timeout',
        title: 'Gateway timeout',
        description: 'There has been a loss of connection. Please re-upload and try again.',
        summary: 'There has been a loss of connection. Please re-upload the following:'
      };
    case 'type':
      return {
        code: 'type',
        title: 'Invalid file type',
        description: 'Your file type must be either: JPEG, JPG, or PNG. Please re-upload.',
        summary:
          'Your file(s) type must be either: JPEG, JPG, or PNG. Please re-upload the following:'
      };
    case 'default':
    default:
      return {
        code: 'default',
        title: 'Unknown error',
        description:
          'An unknown error has occurred. Please verify your internet connection and file format, then re-upload.',
        summary:
          'An unknown error has occurred. Please verify your internet connection and file format, then re-upload the following:'
      };
  }
};

export default imageUploadErrors;
